/**
 * Interface for Flock LPR search parameters.
 *
 * Backend:
 * - Path: fieldwatch-api/src/integrations/connectors/flock_ps/serializers.py
 * - Class: PlateSearchQuerySerializer
 */
export interface IFsLprFlockParameters {
  // Pagination/sorting
  page?: string;
  pageSize?: number;
  maxResults?: number;
  sortOrder?: 'asc' | 'desc';

  // General
  plate?: string;
  fromDate?: string;
  toDate?: string;

  // Additional
  /**
   * flock only support 2 commas seperated coordinates that form a box
   * @url https://axon.quip.com/XNl4AMLfwayD/ALPR-Provider-Geo-Search-Limitations#temp:C:SJbda20bdaf0a7440019c84443de
   */
  inBbox?: string;
  cameras?: string;
}
